import { useEffect } from "react";
import { HomePage } from "Components/pages/HomePage";
import { useSearchContext } from "shared/contexts/SearchContext";
import { GlobalStyles } from "styles/globalStyles";
import { theme } from "styles/theme";
import { ThemeProvider } from "styled-components";

export default function Home() {
  const { updateStateFromParams } = useSearchContext();

  useEffect(() => {
    updateStateFromParams();
  }, [updateStateFromParams]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <HomePage isSERP={false} />
    </ThemeProvider>
  );
}
